export default __webpack_public_path__ + "static/media/ic-teachers.ceb8cf57.svg";